import React from 'react';
import Plans from '../Partials/Plans';

export default () => (
  <div>
    <Plans />
  </div>
);
